import { Paper, Typography } from "@mui/material";
import { ReactNode } from "react";

import { INumeroHoje } from "./types";

export function Numero({ numero, acao }: { numero: INumeroHoje; acao?: ReactNode }) {
  return (
    <Paper variant="outlined" sx={{ p: 2, display: "flex", flexDirection: "column", gap: 1 }}>
      <Typography variant="body2" color="text.secondary">
        {numero.rotulo}
      </Typography>
      <Typography sx={{ fontFamily: "Sora", fontSize: "2rem", fontWeight: 700, lineHeight: 1.2 }}>
        {numero.valor.toLocaleString("pt-BR")}
      </Typography>
      {numero.detalhe && (
        <Typography
          variant="body2"
          color={numero.destaque ? "error.main" : "text.secondary"}
          fontWeight={numero.destaque ? 700 : 400}
        >
          {numero.detalhe}
        </Typography>
      )}
      {acao}
    </Paper>
  );
}
